import { Component, computed, effect, input } from '@angular/core';
import { setTheme, Themes } from 'themes';
import { LandingpageConfiguration } from 'app/shared/models/landingpage-configuration.model';
import { HeaderComponent } from 'app/shared/components/header/header.component';
import { FooterComponent } from 'app/shared/components/footer/footer.component';

@Component({
  selector: 'ez-main-layout',
  imports: [HeaderComponent, FooterComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  readonly landingpageConfig = input<LandingpageConfiguration>();
  readonly theme = input<Themes>(Themes.WHITELABEL);

  readonly footerConfig = computed(() => this.landingpageConfig()?.layoutConfiguration.footer.image);
  readonly headerConfig = computed(() => this.landingpageConfig()?.layoutConfiguration.header.image);

  constructor() {
    effect(() => {
      setTheme(this.theme());
    });
  }
}
